angular.module('Itao.IndicatorMap').directive('districtReport', ['mapConfig', 'communeConfig', function(mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtReport.html',
    scope: {
      selectedDataLayer: '=',
      selectedDistrict: '='
    },
    link: function (scope) {

      var data = getDistrictData();
    }
  }
}]);
